<script setup lang="ts">
import { unref } from 'vue'
import { DataState } from '../../types/types'
import { Skeleton } from '../ui/skeleton'
import TableCell from '../ui/table/TableCell.vue'

const props = defineProps<{
  class?: string
  dataState: DataState
}>()
</script>

<template>
  <TableCell :class="props.class">
    <Skeleton v-if="unref(dataState.isLoading)" class="min-w-6 flex-1 h-5 w-full" />
    <div
      v-else-if="unref(dataState.isError)"
      class="min-w-6 flex-1 h-5 w-full bg-gray-300 rounded-md"
    ></div>
    <slot v-else />
  </TableCell>
</template>
